import React from 'react';
import rightArrow from './../assets/rightArrow.png';


const Pricing = () => {
  return (
        <div className='pt-20'>
        <h1 className='text-center text-[40px] leading-[5rem] text-[#35332F] font-bold py-10 pricing-policy'>Our Pricing Policy</h1>
        <div className='flex justify-center gap-8 pricing-sm'> 
          <div className='basic relative rounded-t-3xl'>
              <p className="pl-10 text-xl text-[#A0A0A0] leading-6 pt-10 pb-2 font-medium	font-['Mulish'] ">Basic Package</p>
              <h1 className="pl-10 font-bold font-[#2f2f2f] text-[66px] font-['Mulish'] leading-[5rem] pb-5">$29</h1>
              <hr />
              <p className="pl-10 font-medium text-sm text-[#929292] font-['Mulish'] leading-4 pt-5 pb-2">WHAT'S INCLUDED</p>
              <p className="pl-10 text-lg leading-6 font-medium text-[#393939] font-['Mulish] py-3">60 Unique Screens</p>
              <p className="pl-10 text-lg leading-6 font-medium text-[#393939] font-['Mulish] py-3">Apps source file</p>
              <p className="pl-10 text-lg leading-6 font-medium text-[#393939] font-['Mulish] py-3">400+ Free fonts</p>
              <p className="pl-10 text-lg leading-6 font-medium text-[#393939] font-['Mulish] py-3">Color source</p>
              <p className="pl-10 text-lg leading-6 font-medium text-[#393939] font-['Mulish] py-3">Icon Included</p>
              <p className="pl-10 text-lg leading-6 font-medium text-[#393939] font-['Mulish] py-3">All Sketch, Figma Files</p>

              
              <div className='flex absolute bottom-0 py-4 text-[#fff] subscribe bg-[#1B1139] cursor-pointer'>
                <p className='pl-10'>Subscribe</p>
                <img src={rightArrow} alt=""/>
              </div>
          </div>

          <div className='premium relative rounded-t-3xl'>
          <p className="pl-10 text-xl text-[#A0A0A0] leading-6 pt-10 py-5 font-medium	font-['Mulish'] ">Premium Package</p>
              <h1 className="pl-10 font-bold font-[#2f2f2f] text-[66px] font-['Mulish'] leading-[5rem] pb-5">$59</h1>
              <hr />
              <p className=" pl-10 font-medium text-sm text-[#929292] font-['Mulish'] leading-4 pt-5 pb-2">WHAT'S INCLUDED</p>
              <p className="pl-10 text-lg leading-6 font-medium text-[#393939] font-['Mulish] py-3">60 Unique Screens</p>
              <p className="pl-10 text-lg leading-6 font-medium text-[#393939] font-['Mulish] py-3">Apps source file</p>
              <p className="pl-10 text-lg leading-6 font-medium text-[#393939] font-['Mulish] py-3">400+ Free fonts</p>
              <p className="pl-10 text-lg leading-6 font-medium text-[#393939] font-['Mulish] py-3">Color source</p>
              <p className="pl-10 text-lg leading-6 font-medium text-[#393939] font-['Mulish] py-3">Icon Included</p>
              <p className="pl-10 text-lg leading-6 font-medium text-[#393939] font-['Mulish] py-3">All Sketch, Figma Files</p>
              <hr />
              
              <p className="pl-10 text-lg leading-6 font-medium text-[#393939] font-['Mulish] py-5">HTML 5</p>
              <p className="pl-10 text-lg leading-6 font-medium text-[#393939] font-['Mulish]">Frontend Support</p>
              <p className="pl-10 text-lg leading-6 font-medium text-[#393939] font-['Mulish] py-5">Web Source</p>

              <div className='subscribe flex absolute text-[#fff] bottom-0 bg-[#52BD95] py-4 cursor-pointer'>
                <p className='pl-10'>Subscribe</p>
                <div>
                <img src={rightArrow} alt=""/>   
                </div>   
              </div>

          </div>
        </div>
    </div>
  )
}

export default Pricing